module.exports = __webpack_public_path__ + "static/img/modal_pro.38133bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor9/modal_pro.png
// module id = Vh4B
// module chunks = 2